<template>
  <div class="header">
    <div class="header-mobile">
      <button class="mobile-nav-open" @click="openMobileMenu"><i class="icon-menu"></i></button>

      <transition name="fade">
        <div class="mobile-nav" v-if="showMobile">
          <div class="mobile-nav-inner">
            <div class="mobile-nav-top">
              <button class="mobile-nav-close" @click="closeMobileMenu"><i class="icon-chevron-b"></i></button>
              <div class="mobile-nav-title">Menu</div>
            </div>
            <ul class="mobile-menu">
              <li
                v-for="(mainMenu, index) in menu"
                :key="index"
                :class="{'active': $route.path === mainMenu.link, 'menu-parent': mainMenu.items}"
              >
                <a @click="trackOpenSectionFromMenu(mainMenu)">
                  <span>{{ mainMenu.name }}</span>
                </a>
              </li>
              <li v-if="ideaBoard" :class="{'active': $route.path === '/profile/ideas'}">
                <router-link to="/profile">
                  <span>Profile</span>
                </router-link>
              </li>
            </ul>
            <ul class="mobile-menu2">
              <li :class="{'active': $route.path === '/engage-for-business'}">
                <router-link :to="{name: 'EngageForBusiness'}">
                  <i class="icon-info"></i>
                  <span>Engage for Business</span>
                </router-link>
              </li>
              <li :class="{'active':  $route.path === '/privacy-policy'}">
                <router-link :to="{name: 'PrivacyPolicy'}">
                  <i class="icon-report"></i>
                  <span>Privacy policy</span>
                </router-link>
              </li>
              <li :class="{'active':  $route.path === '/bookmarks'}">
                <router-link :to="{name: 'Bookmarks'}">
                  <i class="icon-report"></i>
                  <span>Bookmarks</span>
                </router-link>
              </li>
              <li :class="{'active': false}" v-if="$store.getters.userCompanies.length > 1">
                <router-link to="/company-select">
                  <i class="icon-switch-account"></i>
                  <span>Switch account</span>
                </router-link>
              </li>
              <li v-if="!$store.getters.isPublicUser">
                <a @click="logout">
                  <span>Log out</span>
                </a>
              </li>
              <li v-if="$store.getters.isPublicUser">
                <router-link to="/login">
                  <span>Login</span>
                </router-link>
              </li>
            </ul>
            <router-link :to="{name: 'Home'}" class="logo">
              <ImageWrapper :key="$store.getters.company.idLogo" :file="$store.getters.company.idLogo"></ImageWrapper>
              <span>{{$store.getters.company.name}}</span>
            </router-link>
          </div>
        </div>
      </transition>
    </div>

    <div class="header-desktop">
      <div class="header-desktop-bar">
        <Tooltip :tooltip-class="'tooltip--bottom tooltip--onclick header-nav'" :key="$route.path">
          <template v-slot:tooltipButtonTemplate>
            <span class="header-nav-button" @click="trackOpenMenu">
              <i class="icon-menu"></i>
            </span>
          </template>
          <template v-slot:tooltipBubbleTemplate>
            <nav class="desktop-nav">
              <ul>
                <li
                  v-for="(mainMenu, index) in menu"
                  :key="index"
                  :class="{'active': $route.path === mainMenu.link}"
                >
                  <a @click="trackOpenSectionFromMenu(mainMenu)" :class="[{'active': $route.path === mainMenu.link}]">
                    {{ mainMenu.name }}
                  </a>
                </li>
              </ul>
            </nav>
          </template>
        </Tooltip>

        <router-link class="logo" :to="{name: 'Home'}">
          <ImageWrapper :key="$store.getters.company.idLogo" :file="$store.getters.company.idLogo"></ImageWrapper>
          <span>{{$store.getters.company.name}}</span>
        </router-link>

        <Tooltip :tooltip-class="'tooltip--bottom tooltip--onclick header-person'">
          <template v-slot:tooltipButtonTemplate>
            <span class="header-person-img">
              <ImageWrapper v-if="$store.getters.user.idPicture" :file="$store.getters.user.idPicture"></ImageWrapper>
              <i v-else class="icon-person"></i>
            </span>
          </template>
          <template v-slot:tooltipBubbleTemplate>
            <router-link v-if="displayProfileEdit" :to="{name: 'ProfileEdit'}">My Profile</router-link>
            <router-link v-else-if="ideaBoard" :to="{name: 'ProfileIdeas'}">My Profile</router-link>
            <router-link :to="{name: 'Bookmarks'}">Bookmarks</router-link>
            <router-link to="/company-select" v-if="displayCompanySelect">Switch account</router-link>
            <a @click="logout" v-if="!$store.getters.isPublicUser"><i class="icon-logout" ></i> Log out</a>
            <a @click="logout" v-if="$store.getters.isPublicUser"><i class="icon-logout"></i> Login</a>
          </template>
        </Tooltip>

        <Tooltip :tooltip-class="'tooltip--bottom tooltip--onclick header-notifications'" v-if="$store.getters.notificationByCompany && $store.getters.notificationByCompany.length">
          <template v-slot:tooltipButtonTemplate>
            <i class="icon-bell"></i>
            <span class="header-notifications-button-new"></span>
          </template>
          <template v-slot:tooltipBubbleTemplate>
            <NotificationTooltipWrapper />
          </template>
        </Tooltip>

        <router-link v-if="ideaBoard"  :to="{name: 'AddIdea'}" class="button-icon">Add new idea <i class="icon-plus-circle"></i></router-link>
      </div>
    </div>

    <div class="breadcrumbs">
      <div class="container">
        <ul>
          <li><router-link :to="{name: 'Home'}"><span>Home</span></router-link></li>
          <li v-for="(item, index) in breadcrumbItems" :key="index"><router-link :to="item.path"><span v-html="item.name"></span></router-link></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from './Tooltip'
import ImageWrapper from "@/components/general/ImageWrapper";
import {slugify} from "@/helpers/slugify";
import settings from "@/settings";
import NotificationTooltipWrapper from "@/components/notification/NotificationTooltipWrapper";

export default {
  name: 'Header',
  props: ['breadcrumbItems'],
  components: {NotificationTooltipWrapper, ImageWrapper, Tooltip },
  data () {
    return {
      showMobile: false,
    }
  },
  computed: {
    menu() {
      let menu = [
        {
          name: 'Home',
          routeName: 'Home',
          link: '/'
        }
      ];
      menu = {...menu, ...this.$store.getters.menu('menu')}
      return menu
    },
    ideaBoard() {
      let section = this.$store.getters.sectionByCode(settings.MODULES.IDEA_BOARD)
      return section && section.idSettingCompany
    },
    displayCompanySelect() {
      return this.$store.getters.userCompanies.length > 1 || this.$store.getters.publicCompanies.length
    },
    displayProfileEdit() {
      return this.$store.getters.settingsCompanyFlagByCode(settings.SETTING_TYPES_FLAGS.SHOW_PROFILE_EDIT)
    }
  },
  mounted () {
    document.querySelector('body').classList.remove('nooverflow')
  },
  methods: {
    logout() {
      this.$store.dispatch('setToken', '')
      this.$store.dispatch('clearStorage')
      this.$router.push({name: 'Login'})
    },
    openMobileMenu () {
      this.showMobile = true
      this.trackOpenMenu()
      document.querySelector('body').classList.add('nooverflow')
    },
    closeMobileMenu () {
      this.showMobile = false
      document.querySelector('body').classList.remove('nooverflow')
    },
    slugify: slugify,
    trackOpenSectionFromMenu(section) {
      this.$gtag.event('OpenSectionFromHome', {
        'event_category': this.$store.getters.company.name,
        'company_name': this.$store.getters.company.name,
        'event_label': section.routeName,
        'value': section.name
      })
      if(section.webContent) {
        window.open(
          section.link,
          '_blank' // <- This is what makes it open in a new window.
        );
      } else {
        this.$router.push(section.link)
      }
      this.showMobile = false
    },
    trackOpenMenu() {
      this.$gtag.event('SideMenu', {
        'event_category': this.$store.getters.company.name,
        'company_name': this.$store.getters.company.name,
        'event_label': this.$route.name,
        'value': this.$store.getters.company.name
      })
    },
  }
}
</script>

<style>
</style>
